import { writable } from 'svelte/store';
import ComponentServices from '../pages/Services.svelte';
import ComponentAmenagements from '../pages/Amenagements.svelte';
import { idPageServices, idPageServicesAssainissement, idPageServicesBalayage, idPageServicesContact, idPageAmenagements, idPageAmenagementsEnrobes, idPageAmenagementsResines, idPageAmenagementsPavage, idPageAmenagementsContact, namePageServices, namePageServicesAssainissement, namePageServicesBalayage, namePageServicesContact, namePageAmenagements, namePageAmenagementsEnrobes, namePageAmenagementsResines, namePageAmenagementsPavage, namePageAmenagementsContact, } from "./router2";
export const storeCurRoute = writable(idPageServices);
export const routes = [];
export const pageServices = { id: idPageServices, name: namePageServices, anchor: '', component: ComponentServices };
routes.push(pageServices);
export const pageServicesAssainissement = { id: idPageServicesAssainissement, name: namePageServicesAssainissement, anchor: idPageServicesAssainissement, component: ComponentServices };
routes.push(pageServicesAssainissement);
export const pageServicesBalayage = { id: idPageServicesBalayage, name: namePageServicesBalayage, anchor: idPageServicesBalayage, component: ComponentServices };
routes.push(pageServicesBalayage);
export const pageServicesContact = { id: idPageServicesContact, name: namePageServicesContact, anchor: idPageServicesContact, component: ComponentServices };
routes.push(pageServicesContact);
export const pageAmenagements = { id: idPageAmenagements, name: namePageAmenagements, anchor: '', component: ComponentAmenagements };
routes.push(pageAmenagements);
export const pageAmenagementsEnrobes = { id: idPageAmenagementsEnrobes, name: namePageAmenagementsEnrobes, anchor: idPageAmenagementsEnrobes, component: ComponentAmenagements };
routes.push(pageAmenagementsEnrobes);
export const pageAmenagementsResines = { id: idPageAmenagementsResines, name: namePageAmenagementsResines, anchor: idPageAmenagementsResines, component: ComponentAmenagements };
routes.push(pageAmenagementsResines);
export const pageAmenagementsPavage = { id: idPageAmenagementsPavage, name: namePageAmenagementsPavage, anchor: idPageAmenagementsPavage, component: ComponentAmenagements };
routes.push(pageAmenagementsPavage);
export const pageAmenagementsContact = { id: idPageAmenagementsContact, name: namePageAmenagementsContact, anchor: idPageAmenagementsContact, component: ComponentAmenagements };
routes.push(pageAmenagementsContact);
/**
 * redirectTo
 *
 * @param path
 */
export function redirectTo(idPage) {
    storeCurRoute.set(idPage);
    // push the path into web browser history API
    window.history.pushState({ path: "#" + idPage }, '', window.location.origin);
}
/**
 * historyNavigation
 * Écoute de l’événement popstate qui est lancé lorsque l’historique change.
 * Le clic sur le back du navigateur est écouté et la route courante actualisée
 *
 * @param event
 */
export function historyNavigation(event) {
    // change current router path
    if (event.state.path.indexOf("#") >= 0 && storeCurRoute != undefined) {
        storeCurRoute.set(event.state.path.replace('#', ''));
    }
}
